import { gsap } from 'gsap'
import EventEmitter from '../Utils/EventEmitter'

export default class StartButton extends EventEmitter {
  constructor() {
    super()
    this.element = document.querySelector('#startButton')
    this.isProcessing = false
    
    this.setupEvents()
  }

  show() {
    this.element.classList.add('visible')
    // フェードイン効果
    gsap.fromTo(this.element,
      { opacity: 0 },
      { opacity: 1, duration: 2.0, ease: "power2.out" }
    )
  }

  hide() {
    // フェードアウト効果
    gsap.to(this.element, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        this.element.classList.remove('visible')
      }
    })
  }

  disable() {
    this.element.classList.add('disabled')
    this.isProcessing = true
  }

  enable() {
    this.element.classList.remove('disabled')
    this.isProcessing = false
  }

  setupEvents() {
    const handleStart = () => {
      if (this.isProcessing) return // 既に処理中の場合は何もしない

      this.disable()
      this.hide()

      // StartButtonがクリックされたことを通知
      this.trigger('click')
    }

    this.element.addEventListener('click', handleStart)

    // タッチイベントも対応
    this.element.addEventListener('touchstart', (e) => {
      e.preventDefault() // clickイベントの重複実行を防ぐ
      handleStart()
    })
  }
}